import { render } from "./MisEtiquetas.vue?vue&type=template&id=2fb6f9c6"
import script from "./MisEtiquetas.vue?vue&type=script&lang=js"
export * from "./MisEtiquetas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__